const state = {
    clientcontact : [],
    suppliercontact : [],
    taxes: [],
    compteGL: [],
    suppliers : [],
    clients : [],
    allData : [],
    items : [],
    inventory : [],
}
const getters = {
    getClientContactsOnClient: (state) => {
        return state.clientcontact
    },
    getSupplierContactsOnClient: (state) => {
        return state.suppliercontact
    },
    getSuppliersOnClient: (state) => {
        return state.suppliers
    },
    getTaxes: (state) => {
        return state.taxes
    },
    getCompteGL: (state) => {
        return state.compteGL
    },
    getClients: (state) => {
        return state.clients
    },
    getAllData : (state) => {
        return state.allData
    },
    getItems: (state) => {
        return state.items
    },
    getInventory: (state) => {
        return state.inventory
    },
}
const mutations = {
    UPDATE_ALLDATA : (state, payload) => {
        state.allData = payload
    },
    UPDATE_CLIENT_CONTACTS : (state, payload) => {
        state.clientcontact = payload
    },
    UPDATE_SUPPLIER_CONTACTS : (state, payload) => {
        state.suppliercontact = payload
    },

    AFTER_UPDATE : (state, payload) => {
        let updatedData  = JSON.parse(payload)
        let storeName = updatedData.storeName
        let data = updatedData.payload
        switch(storeName) {
            case 'suppliers':
                state.suppliers.data.supplierList.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'suppliercontact':
                state.suppliercontact.data.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'clientcontact':
                state.clientcontact.data.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'clients':
                state.clients.data.client.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
                
        }
    }, 
    AFTER_INSERT : (state, payload) => {
        let newData  = JSON.parse(payload)
        let storeName = newData.storeName
        let data = newData.payload
        switch(storeName) {
            case 'suppliers':
                state.suppliers.data.supplierList.push(data)
                break;
            case 'suppliercontact':
                state.suppliercontact.data.push(data)
                break;
            case 'clientcontact':
                state.clientcontact.data.push(data)
                break;
            case 'clients':
                state.clients.data.client.push(data)
                break;
        }
    }, 
    AFTER_DELETE : (state, payload) => {
        let deletedData  = JSON.parse(payload)
        let storeName = deletedData.storeName
        let data = deletedData.payload
        switch(storeName) {
            case 'suppliers':
                state.suppliers.data.supplierList.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'suppliercontact':
                state.suppliercontact.data.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'clientcontact':
                state.clientcontact.data.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
            case 'clients':
                state.clients.data.client.map((item) => (item.id === data.id ? Object.assign(item,data) : item))
                break;
        }
    }, 

    UPDATE_TAXES : (state, payload) => {
        state.taxes = payload
    },
    UPDATE_GL_ACCOUNTS : (state, payload) => {
        state.compteGL = payload
    },
    UPDATE_SUPPLIERS : (state, payload) => {
        state.suppliers = payload
    },
    UPDATE_CLIENTS : (state, payload) => {
        state.clients = payload
    }, 
    UPDATE_ITEMS : (state, payload) => {
        state.items = payload
    },
    UPDATE_INVENTORY  : (state, payload) => {
        state.inventory = payload
    },

    DELETE_ALLDATA : (state) => {
        state.allData = []
    },
    DELETE_CLIENT_CONTACTS : (state) => {
        state.clientcontact = []
    },
    DELETE_SUPPLIER_CONTACTS : (state) => {
        state.suppliercontact = []
    },
    DELETE_TAXES : (state) => {
        state.taxes = []
    },
    DELETE_GL_ACCOUNTS : (state) => {
        state.compteGL = []
    },
    DELETE_CLIENTS : (state) => {
        state.clients = []
    },
    DELETE_ITEMS : (state) => {
        state.items = []
    },
    DELETE_INVENTORY  : (state) => {
        state.inventory = []
    },
}
const actions = {
    initAllData(context, payload) {
        const allData = payload
        context.commit('UPDATE_ALLDATA',            allData)
        context.commit('UPDATE_CLIENT_CONTACTS',    allData[0])
        context.commit('UPDATE_SUPPLIER_CONTACTS',  allData[1])
        context.commit('UPDATE_TAXES',              allData[2])
        context.commit('UPDATE_GL_ACCOUNTS',        allData[3])
        //context.commit('UPDATE_CLIENTS',            allData[5])
        context.commit('UPDATE_INVENTORY',          allData[5])
    },
    updateTaxes             :  (context, payload) => context.commit('UPDATE_TAXES',            payload),
    updateGLAccounts        :  (context, payload) => context.commit('UPDATE_GL_ACCOUNTS',      payload),
    updateClientContacts    :  (context, payload) => context.commit('UPDATE_CLIENT_CONTACTS',  payload),
    updateSupplierContacts  :  (context, payload) => context.commit('UPDATE_SUPPLIER_CONTACTS',payload),
    updateSuppliers         :  (context, payload) => context.commit('UPDATE_SUPPLIERS',        payload),
    updateClients           :  (context, payload) => context.commit('UPDATE_CLIENTS',          payload),

    updateItems             :  (context, payload) => context.commit('UPDATE_ITEMS',            payload),

    afterUpdate             :  (context, payload) => context.commit('AFTER_UPDATE',            payload),
    afterInsert             :  (context, payload) => context.commit('AFTER_INSERT',            payload),
    afterDelete             :  (context, payload) => context.commit('AFTER_DELETE',            payload),

    clearAllData :  (context) => {
        context.commit('DELETE_ALLDATA'          )
        context.commit('DELETE_CLIENT_CONTACTS'  )
        context.commit('DELETE_SUPPLIER_CONTACTS')
        context.commit('DELETE_TAXES'            )
        context.commit('DELETE_GL_ACCOUNTS'      )
        context.commit('DELETE_CLIENTS'          )
        context.commit('DELETE_ITEMS'            )
        context.commit('DELETE_INVENTORY'        )
    }
}

export default{
    state,
    mutations,
    getters,
    actions
}